/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */

export const generateMagazineHeaderSettings = () => {
  let rowSettings = [
    { label: "Background Color", type: "colorPicker", keyName: "theme" },
    {
      label: "Subscribe Button",
      type: "checkbox",
      keyName: "showButton"
    },
    {
      label: "Button Text",
      type: "text",
      keyName: "buttonText"
    },
    {
      label: "Button Link",
      type: "text",
      keyName: "customUrlPath"
    }
  ];
  return { settings: rowSettings };
};

export const generateMagazineEditionsSettings = () => {
  let rowSettings = [
    { label: "Show Row Title", type: "checkbox", keyName: "showRowTitle" },
    { label: "Row title", type: "text", keyName: "rowTitle" },
    { label: "Background Color", type: "colorPicker", keyName: "theme" },
    {
      label: "Magazine Title",
      type: "dropDown",
      keyName: "editionNameFormat",
      dropDownOptions: [
        { label: "Issue Date", value: "magazineDate" },
        { label: "Magazine Name", value: "magazineTitle" }
      ]
    }
  ];
  return { settings: rowSettings };
};

export const generateMagazineWidgetSettings = () => {
  const showHideSettings = [
    {
      label: "Row Title",
      type: "checkbox",
      keyName: "showRowTitle"
    },
    {
      label: "Author Name",
      type: "checkbox",
      keyName: "showAuthor"
    },
    {
      label: "Publish Time",
      type: "checkbox",
      keyName: "showTime"
    },
    {
      label: "Time to read",
      type: "checkbox",
      keyName: "showReadTime"
    }
  ];
  const styleSettings = [
    { label: "Theme", type: "colorPicker", keyName: "theme" },
    {
      label: "Border",
      type: "dropDown",
      keyName: "border",
      dropDownOptions: [{ label: "No Border", value: "" }, { label: "With Border", value: "borderBottom" }]
    }
  ];

  const showHideButtonSettings = [
    {
      label: "Enable Button",
      type: "checkbox",
      keyName: "showButton"
    }
  ];

  const buttonSettings = [
    {
      label: "Button Text",
      type: "text",
      keyName: "buttonText",
      placeholder: "Read More"
    },
    {
      label: "Button Link",
      type: "text",
      keyName: "customUrlPath"
    }
  ];

  return { showHideSettings, styleSettings, buttonSettings, showHideButtonSettings };
};
